import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useEffect } from "react";
import { useFetcher } from "@rest-hooks/core";
import { Grid, Paper, Button, List, ListItem, ListItemSecondaryAction, Checkbox, ListItemText, ListItemIcon } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { ApplicationSignerResource, SigningDocumentResource, useResourceWithInvalidate } from "@ploy-lib/rest-resources";
import { AppSignerForm } from "./AppSignerForm";
import { FormattedMessage, injectIntl, defineMessages } from "react-intl";
import { EsignType } from "@ploy-lib/types";
const messages = defineMessages({
    addSigner: {
        id: "core.application-signing.signer-list.add-new",
        defaultMessage: "Add new signing subject"
    }
});
const AppSignerList = injectIntl((props) => {
    const { applicationNumber, documents, intl, onEdit, ssnServiceEnabled, esignType, selfEmployedCustomer = false, showValidPeriod, canAddAndDelete, canChooseSigners, canEditIndividualDocuments, disabled, mustSignDefaultChecked, guarantorId, hideDocumentsToSign, signerType } = props;
    const signers = useResourceWithInvalidate(ApplicationSignerResource.list(), {
        signerType,
        applicationNumber,
        customerId: guarantorId
    });
    const updateSigner = useFetcher(ApplicationSignerResource.update());
    const [selected, setSelected] = useState(null);
    const goBack = useCallback(() => {
        setSelected(null);
    }, []);
    const refetchSigners = useFetcher(ApplicationSignerResource.list());
    const refetchDocuments = useFetcher(SigningDocumentResource.list());
    const onSuccess = useCallback(() => {
        refetchSigners({
            applicationNumber,
            signerType,
            customerId: guarantorId
        });
        refetchDocuments({ applicationNumber: applicationNumber });
        goBack();
    }, [
        refetchSigners,
        applicationNumber,
        signerType,
        guarantorId,
        refetchDocuments,
        goBack
    ]);
    useEffect(() => onEdit && onEdit(selected != null || selected === undefined), [selected, onEdit]);
    const allDocsAreSigned = documents && documents.every(d => d.signed);
    const canAddSigner = !allDocsAreSigned &&
        !selfEmployedCustomer &&
        esignType !== EsignType.SsnNotRequired &&
        canAddAndDelete &&
        !disabled;
    const canEditDocuments = !selfEmployedCustomer;
    if (selected !== null) {
        return (_jsx(Paper, { elevation: 0, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsxs(Button, { onClick: goBack, children: [_jsx(ChevronLeftIcon, {}), _jsx(FormattedMessage, { id: "core.application-signing.signer-list.go-back", defaultMessage: "Back" })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(AppSignerForm, { applicationNumber: applicationNumber, signer: selected, documents: documents, disabled: allDocsAreSigned || disabled, onSuccess: onSuccess, canEditDocuments: canEditDocuments, canEditIndividualDocuments: canEditIndividualDocuments, esignType: esignType, ssnServiceEnabled: ssnServiceEnabled, showValidPeriod: showValidPeriod, mustSignDefaultChecked: mustSignDefaultChecked, guarantorId: guarantorId, hideDocumentsToSign: hideDocumentsToSign, signerType: signerType }) })] }) }));
    }
    return (_jsx(Paper, { elevation: 0, children: _jsxs(List, { dense: true, children: [signers &&
                    signers.map((signer, i) => (_jsxs(ListItem, { button: true, onClick: () => setSelected(signer), children: [_jsx(ListItemIcon, { children: _jsx(ChevronRightIcon, {}) }), _jsx(ListItemText, { primary: `${signer.lastName} ${signer.firstName}`, secondary: signer.dataValidationErrorMessage
                                    ? signer.dataValidationErrorMessage
                                    : signer.role || " ", secondaryTypographyProps: signer.dataValidationErrorMessage
                                    ? { color: "error" }
                                    : undefined }), _jsx(ListItemSecondaryAction, { children: canChooseSigners ||
                                    (signer.mustSign && !selfEmployedCustomer) ? (_jsx(Checkbox, { color: "primary", onChange: (event) => {
                                        if (canChooseSigners) {
                                            updateSigner({ signerType: signerType }, {
                                                ...signer,
                                                mustSign: event.target.checked
                                            }).then(() => {
                                                onSuccess();
                                            });
                                        }
                                        else if (signer.mustSign) {
                                            updateSigner({ signerType: signerType }, {
                                                ...signer,
                                                mustSign: false
                                            }).then(() => {
                                                onSuccess();
                                            });
                                        }
                                    }, checked: signer.mustSign, disabled: allDocsAreSigned ||
                                        Boolean(signer.applicationSignerId &&
                                            documents &&
                                            documents.some(d => d.signed &&
                                                d.signers.includes(signer.applicationSignerId))) ||
                                        !signer.canSetMustSign })) : null })] }, signer.applicationSignerId
                        ? signer.applicationSignerId.toString()
                        : i.toString()))), !canAddSigner ? null : (_jsxs(ListItem, { button: true, onClick: () => setSelected(undefined), children: [_jsx(ListItemIcon, { children: _jsx(AddIcon, {}) }), _jsx(ListItemText, { primary: intl.formatMessage(messages.addSigner) })] }))] }) }));
});
AppSignerList.displayName = "DployAppSignerList";
export { AppSignerList };
//# sourceMappingURL=AppSignerList.js.map